/**
 * Body measurement interactive visual — Design Update 2 ONLY.
 * Isolated API: window.StAgniBodyMeasurementVisualD2
 * - Single waist zoom; all 3 lines visible
 * - Hover / click / touch loops that line's draw animation (labels stay)
 * - Type buttons show dynamic values (Bust: 80cm)
 */
(function (window, document) {
  'use strict';

  var Y_SCALE = 876 / 216;

  /* Locked camera = Design Update 1 waist zoom */
  var lockedView = {
    zoom: 2.5,
    x: 0,
    y: 0,
    originX: 50,
    originY: 33
  };

  var measurementRegions = {
    bust: {
      line: { y: 26, x1: 28, x2: 72, curve: 1.4, labelY: 29.5 }
    },
    waist: {
      line: { y: 33, x1: 30, x2: 70, curve: 1.1, labelY: 36.5 }
    },
    hip: {
      line: { y: 42, x1: 19, x2: 79, curve: 1.6, labelY: 45.5 }
    }
  };

  var TYPE_ORDER = ['bust', 'waist', 'hip'];
  var SIZE_OPTION_RE = /size|taille|größe|gr\u00f6\u00dfe|tamanho|tama\u00f1o|koko|\u30b5\u30a4\u30ba/i;
  var initialized = new WeakSet();

  function getProductData() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSizeOptionIndex(product) {
    if (!product || !product.options) return 0;
    for (var i = 0; i < product.options.length; i++) {
      if (SIZE_OPTION_RE.test(product.options[i])) return i;
    }
    return 0;
  }

  function variantSize(variant, product) {
    if (!variant || !product) return null;
    var idx = getSizeOptionIndex(product);
    return variant['option' + (idx + 1)] || variant.option1;
  }

  function getPdpSize() {
    var data = getProductData();
    if (data && data.product && data.selected_variant_id) {
      var variant = data.product.variants.find(function (v) {
        return v.id === data.selected_variant_id;
      });
      var size = variantSize(variant, data.product);
      if (size) return normalizeSize(size);
    }
    var checked = document.querySelector('.ProductForm__Option .SizeSwatch__Radio:checked');
    return checked ? normalizeSize(checked.value) : null;
  }

  function normalizeSize(label) {
    return String(label || '').trim().toUpperCase();
  }

  function parseTableData(table) {
    var headers = [];
    var ths = table.querySelectorAll('thead th');
    for (var i = 1; i < ths.length; i++) {
      headers.push(normalizeSize(ths[i].textContent.replace(/\s*\((?:cm|in)\)\s*$/i, '')));
    }

    var measurements = { bust: {}, waist: {}, hip: {} };
    var rows = table.querySelectorAll('tbody tr');
    rows.forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (!cells.length) return;
      var key = String(cells[0].textContent).trim().toLowerCase();
      if (!measurements[key]) return;
      for (var c = 1; c < cells.length; c++) {
        var size = headers[c - 1];
        if (!size) continue;
        var cm = cells[c].getAttribute('data-cm');
        if (cm == null) {
          var parsed = parseFloat(String(cells[c].textContent).replace(',', '.'));
          if (!isNaN(parsed)) cm = String(parsed);
        }
        if (cm != null) measurements[key][size] = parseFloat(cm);
      }
    });
    return { sizes: headers, measurements: measurements };
  }

  function formatValueShort(cm, unit) {
    if (cm == null || isNaN(cm)) return '—';
    if (unit === 'in') {
      var inches = cm / 2.54;
      var s = inches.toFixed(1);
      if (s.endsWith('.0')) s = s.slice(0, -2);
      return s + 'in';
    }
    var out = parseFloat(cm).toFixed(1);
    if (out.endsWith('.0')) out = out.slice(0, -2);
    return out + 'cm';
  }

  function getMeasurementValue(data, type, size) {
    if (!data || !data.measurements || !data.measurements[type]) return null;
    return data.measurements[type][size];
  }

  function getActiveUnit(grid) {
    var active = grid.querySelector('.unit-link.is-active');
    return active && active.getAttribute('data-unit') === 'in' ? 'in' : 'cm';
  }

  function clearSvg(svg) {
    if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
  }

  function fitDashArray(path, dashLen, gapLen) {
    var length = path.getTotalLength();
    if (!length || !isFinite(length)) return dashLen + ' ' + gapLen;
    var n = Math.max(2, Math.round((length + gapLen) / (dashLen + gapLen)));
    var fittedGap = (length - n * dashLen) / (n - 1);
    if (fittedGap < 0.6 || fittedGap > gapLen * 3) {
      fittedGap = gapLen;
      var fittedDash = (length - (n - 1) * fittedGap) / n;
      if (fittedDash > 0.4) return fittedDash + ' ' + fittedGap;
      return dashLen + ' ' + gapLen;
    }
    return dashLen + ' ' + fittedGap;
  }

  function applyView(viewport, view) {
    if (!viewport || !view) return;
    viewport.style.transformOrigin = view.originX + '% ' + view.originY + '%';
    viewport.style.transform = 'scale(' + view.zoom + ') translate(' + view.x + '%, ' + view.y + '%)';
  }

  function BodyMeasurementVisualD2(grid) {
    this.grid = grid;
    this.panel = grid.closest('[id^="tab-body-measurements"]');
    this.root = this.panel
      ? this.panel.querySelector('[data-body-measurement-visual-d2]')
      : grid.querySelector('[data-body-measurement-visual-d2]');
    this.table = grid.querySelector('.body-measurements-table');
    this.viewport = this.root && this.root.querySelector('[data-bm-viewport]');
    this.svg = this.root && this.root.querySelector('[data-bm-svg]');
    this.sizeMenu = this.root && this.root.querySelector('[data-bm-size-menu]');
    this.srValueEl = this.root && this.root.querySelector('[data-bm-sr-value]');
    this.typeButtons = this.root ? this.root.querySelectorAll('[data-bm-type]') : [];
    this._looping = false;
    this._loopType = null;
    this._onAnimEnd = null;
    this._stickyLoop = false;
    this.state = {
      type: 'bust',
      size: null,
      unit: 'cm',
      data: null
    };
  }

  BodyMeasurementVisualD2.prototype.init = function () {
    if (!this.root || !this.table) return;
    if (initialized.has(this.grid)) return;
    initialized.add(this.grid);

    this.state.data = parseTableData(this.table);
    this.state.unit = getActiveUnit(this.grid);
    this.state.size = this.resolveInitialSize();
    this.state.type = 'bust';

    this.buildSizeMenu();
    this.bindEvents();
    this.root.removeAttribute('hidden');
    this.syncSizeActive();
    this.syncTypeActive();
    applyView(this.viewport, lockedView);
    this.render();
  };

  BodyMeasurementVisualD2.prototype.resolveInitialSize = function () {
    var pdp = getPdpSize();
    if (pdp && this.state.data.sizes.indexOf(pdp) !== -1) return pdp;
    if (this.state.data.sizes.indexOf('M') !== -1) return 'M';
    return this.state.data.sizes[0] || 'M';
  };

  BodyMeasurementVisualD2.prototype.syncSizeActive = function () {
    var size = this.state.size;
    if (!this.sizeMenu) return;
    this.sizeMenu.querySelectorAll('[data-bm-size-option]').forEach(function (btn) {
      var active = btn.getAttribute('data-bm-size-option') === size;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  };

  BodyMeasurementVisualD2.prototype.syncTypeActive = function () {
    var type = this.state.type;
    this.typeButtons.forEach(function (btn) {
      var active = btn.getAttribute('data-bm-type') === type;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  };

  BodyMeasurementVisualD2.prototype.buildSizeMenu = function () {
    var self = this;
    this.sizeMenu.innerHTML = '';
    this.state.data.sizes.forEach(function (size) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bm-visual__size-option';
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-bm-size-option', size);
      btn.textContent = size;
      li.appendChild(btn);
      self.sizeMenu.appendChild(li);
    });
  };

  BodyMeasurementVisualD2.prototype.bindEvents = function () {
    var self = this;

    this.typeButtons.forEach(function (btn) {
      var type = btn.getAttribute('data-bm-type');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self._stickyLoop = true;
        self.selectType(type);
        self.startLineLoop(type);
      });

      btn.addEventListener('pointerenter', function () {
        // Hover loops this line; underline only changes on click/touch
        self.startLineLoop(type, { select: false });
      });

      btn.addEventListener('pointerleave', function () {
        self.stopLineLoop();
        // After click/touch, keep looping the selected type (needed for touch)
        if (self._stickyLoop && self.state.type) {
          self.startLineLoop(self.state.type, { select: false });
        }
      });
    });

    this.sizeMenu.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bm-size-option]');
      if (!btn) return;
      self.setSize(btn.getAttribute('data-bm-size-option'));
    });

    this.grid.addEventListener('bodyMeasurements:unitChanged', function (e) {
      if (!e.detail) return;
      self.state.unit = e.detail.unit === 'in' ? 'in' : 'cm';
      self.render({ preserveLoop: true });
    });

    document.addEventListener('variant:changed', function () {
      if (!self.grid.closest('.sizeguide-prototype-panel.is-active')) return;
      var pdp = getPdpSize();
      if (pdp) self.setSize(pdp);
    });
  };

  BodyMeasurementVisualD2.prototype.selectType = function (type) {
    if (!measurementRegions[type]) return;
    this.state.type = type;
    this.syncTypeActive();
    this.updateSr();
  };

  BodyMeasurementVisualD2.prototype.setSize = function (size) {
    size = normalizeSize(size);
    if (this.state.data.sizes.indexOf(size) === -1) return;
    this.state.size = size;
    this.syncSizeActive();
    this.render({ preserveLoop: true });
  };

  BodyMeasurementVisualD2.prototype.updateSr = function () {
    var type = this.state.type;
    var cm = getMeasurementValue(this.state.data, type, this.state.size);
    var valueText = formatValueShort(cm, this.state.unit);
    var typeLabel = type.charAt(0).toUpperCase() + type.slice(1);
    if (this.srValueEl) {
      this.srValueEl.textContent = typeLabel + ', size ' + this.state.size + ', ' + valueText;
    }
  };

  BodyMeasurementVisualD2.prototype.updateButtonValues = function () {
    var self = this;
    var size = this.state.size;
    var unit = this.state.unit;
    this.root.querySelectorAll('[data-bm-type-value]').forEach(function (el) {
      var type = el.getAttribute('data-bm-type-value');
      var cm = getMeasurementValue(self.state.data, type, size);
      el.textContent = ': ' + formatValueShort(cm, unit);
    });
  };

  BodyMeasurementVisualD2.prototype.drawAllLines = function () {
    var self = this;
    var svg = this.svg;
    var size = this.state.size;
    var unit = this.state.unit;
    var ns = 'http://www.w3.org/2000/svg';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    clearSvg(svg);
    applyView(this.viewport, lockedView);

    TYPE_ORDER.forEach(function (key) {
      var region = measurementRegions[key];
      if (!region || !region.line) return;
      var l = region.line;
      var y = l.y * Y_SCALE;
      var x1 = l.x1;
      var x2 = l.x2;
      var cx = (x1 + x2) / 2;
      var cy = y + (l.curve || 2) * Y_SCALE;
      var labelY = (l.labelY != null ? l.labelY : (l.y + 3.5)) * Y_SCALE;
      var valueText = formatValueShort(getMeasurementValue(self.state.data, key, size), unit);

      var path = document.createElementNS(ns, 'path');
      path.setAttribute('class', 'bm-measure-path');
      path.setAttribute('data-bm-line', key);
      path.setAttribute('d', 'M ' + x1 + ' ' + y + ' Q ' + cx + ' ' + cy + ' ' + x2 + ' ' + y);
      svg.appendChild(path);
      path.setAttribute('stroke-dasharray', fitDashArray(path, 2.5, 2.2));

      var text = document.createElementNS(ns, 'text');
      text.setAttribute('class', 'bm-measure-value');
      text.setAttribute('data-bm-line-label', key);
      text.setAttribute('x', cx);
      text.setAttribute('y', labelY);
      text.textContent = valueText;
      svg.appendChild(text);
    });

    if (reduceMotion) return;
  };

  BodyMeasurementVisualD2.prototype.render = function (opts) {
    var preserveLoop = !!(opts && opts.preserveLoop);
    var loopingType = preserveLoop && this._looping ? this._loopType : null;
    this.stopLineLoop();
    this.drawAllLines();
    this.updateButtonValues();
    this.updateSr();
    if (loopingType) this.startLineLoop(loopingType);
  };

  BodyMeasurementVisualD2.prototype.restartPathAnim = function (path) {
    if (!path) return;
    path.classList.remove('is-drawing', 'is-redraw');
    // force reflow so animation restarts
    void path.getBoundingClientRect();
    path.classList.add('is-drawing', 'is-redraw');
  };

  BodyMeasurementVisualD2.prototype.startLineLoop = function (type, opts) {
    var self = this;
    if (!measurementRegions[type] || !this.svg) return;

    var shouldSelect = !(opts && opts.select === false);
    if (shouldSelect) this.selectType(type);

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      if (shouldSelect) this.selectType(type);
      return;
    }

    if (this._looping && this._loopType === type) return;

    this.stopLineLoop();

    var path = this.svg.querySelector('[data-bm-line="' + type + '"]');
    if (!path) return;

    this._looping = true;
    this._loopType = type;
    this._onAnimEnd = function (e) {
      if (e.target !== path) return;
      if (!self._looping || self._loopType !== type) return;
      self.restartPathAnim(path);
    };
    path.addEventListener('animationend', this._onAnimEnd);
    this.restartPathAnim(path);
  };

  BodyMeasurementVisualD2.prototype.stopLineLoop = function () {
    var type = this._loopType;
    var path = type && this.svg ? this.svg.querySelector('[data-bm-line="' + type + '"]') : null;
    if (path && this._onAnimEnd) {
      path.removeEventListener('animationend', this._onAnimEnd);
      path.classList.remove('is-drawing', 'is-redraw');
    }
    this._looping = false;
    this._loopType = null;
    this._onAnimEnd = null;
  };

  window.StAgniBodyMeasurementVisualD2 = {
    lockedView: lockedView,
    measurementRegions: measurementRegions,
    init: function (gridEl) {
      if (!gridEl) return;
      var instance = new BodyMeasurementVisualD2(gridEl);
      instance.init();
      return instance;
    },
    refresh: function (gridEl) {
      if (!gridEl || !initialized.has(gridEl)) return;
      initialized.delete(gridEl);
      window.StAgniBodyMeasurementVisualD2.init(gridEl);
    }
  };
})(window, document);
